import React from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import { Link } from 'react-router';

import Button from 'components/atoms/Button';

import styles from './index.css';

const Cookie = ({ className, t, onAgreeCookie, routeName }) => (
	<div className={classnames(className, styles.cookie)}>
		<h5>{t('title')}</h5>
		<div className={styles.sectionBottom}>
			<p>
				{t('description')}{' '}
				<Link className="underline" to={`${routeName}/privacy`}>
					{t('policy')}
				</Link>
			</p>
			<Button onClick={onAgreeCookie}>{t('buttonText')}</Button>
		</div>
	</div>
);

export default translate('cookie')(Cookie);



// WEBPACK FOOTER //
// ./src/components/organisms/Cookie/index.js